//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    components: {
        AQModal,
        AQCard
    },
    filters: {
        convertToHHMM(val, tFrame) {
            let secs = val * 60;
            let sign = "";
            if (val < 0 && tFrame) {
                sign = "-";
            } else if (val === 0 && tFrame) {
                sign = "";
            } else if (tFrame) {
                sign = "+";
            }
            secs = Math.abs(secs);
            const hours = Math.floor(secs / (60 * 60));
            const divisorForMinutes = secs % (60 * 60);
            const minutes = Math.floor(divisorForMinutes / 60);
            const divisorForSeconds = divisorForMinutes % 60;
            const seconds = Math.ceil(divisorForSeconds);
            return (
                `${sign
                + String(hours).padStart(2, "0")
                }:${
                    String(minutes).padStart(2, "0")
                }:${
                    String(seconds).padStart(2, "0")}`
            );
        }
    },
    props: {
        turnaroundTime: String
    },
    data() {
        return {
            appMatrixModal: true,
            levelDetailsAppMatrix: [],
            saved: false,
            hasSave: true,
            readonly: true
        };
    },
    computed: {
        ...mapGetters("reports", ["turaroundTypes", "getStatsPerLevels", "getAppMatrixUncompletedTasks"]),
        ...mapGetters("diagrams", ["diagramData", "diagramConfigData"]),
        turnaroundTimeValue() {
            let label;
            if (this.turnaroundTime === "ONE_WEEK") {
                label = this.$t("liveView.statistics.oneWeek");
            } else if (this.turnaroundTime === "TWO_WEEKS") {
                label = this.$t("liveView.statistics.twoWeeks");
            } else {
                label = this.$t("liveView.statistics.month");
            }
            return label;
        }
    },

    created() {
        for (let i = 0; i < this.getAppMatrixUncompletedTasks.length; i++) {
            this.levelDetailsAppMatrix.push({
                levelName: this.getAppMatrixUncompletedTasks[i].levelName,
                onTrack: this.getAppMatrixUncompletedTasks[i].onTrack,
                attention: this.getAppMatrixUncompletedTasks[i].attention,
                overdue: this.getAppMatrixUncompletedTasks[i].overdue,
                warning: this.getAppMatrixUncompletedTasks[i].warning,
                total: this.getAppMatrixUncompletedTasks[i].total,
                currentTimeFrameTat: null,
                deadline: null,
                previousTimeFrameTat: null,
                timeFrameVariation: null,
                totalCompleted: 0
            });
            for (let j = 0; j < this.getStatsPerLevels.levels.length; j++) {
                if (this.getAppMatrixUncompletedTasks[i].levelId === this.getStatsPerLevels.levels[j].activityId) {
                    this.levelDetailsAppMatrix[i].currentTimeFrameTat = this.getStatsPerLevels.levels[j].currentTimeFrameTat;
                    this.levelDetailsAppMatrix[i].deadline = this.getStatsPerLevels.levels[j].deadline;
                    this.levelDetailsAppMatrix[i].previousTimeFrameTat = this.getStatsPerLevels.levels[j].previousTimeFrameTat;
                    this.levelDetailsAppMatrix[i].timeFrameVariation = this.getStatsPerLevels.levels[j].timeFrameVariation;
                    this.levelDetailsAppMatrix[i].totalCompleted = this.getStatsPerLevels.levels[j].totalCompleted;
                }
            }
        }
    },

    methods: {
        ...mapActions("reports", ["getAppMatrixUncompletedTasksInfo"]),
        actionsDlg() {
            this.appMatrixModal = false;
        },
        timeVarStyle(value) {
            let elToReturn = "";
            if (value) {
                const str = value.toString();
                if (str.charAt(0) === "-") {
                    elToReturn = "color: green";
                } else if (str === "0") {
                    elToReturn = "color:#656565";
                } else {
                    elToReturn = "color: red";
                }
            }
            return elToReturn;
        },
        afterHide() {
            this.$emit("modalClosed");
            this.$emit("input", false);
        }
    }
};
